export default __webpack_public_path__ + "static/media/placeholder_landscape_white.d7dc2af8.svg";